import {
  subclass,
  property,
} from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import { messageBundle, storeNode, tsx } from "@arcgis/core/widgets/support/widget";

import "./FeaturedArticle/FeaturedArticle.scss";

import AppT9N from "../../t9n/App/App.json";
import NavBarViewModel from "./NavBar/NavBarViewModel";

import { VNode } from "src/interfaces/interfaces";

import ChartViewerTitlePic from "../../../public/assets/featuredArticle/chartViewerArticle/chartViewerHeaderPic.png";
import selectionGIF from "../../../public/assets/featuredArticle/chartViewerArticle/selectiongif.gif";
import museumExamplePic from "../../../public/assets/featuredArticle/chartViewerArticle/museumExample.png";

import SidebarTitlePic from "../../../public/assets/featuredArticle/sidebarArticle/sidebarTitlePic.png";
import basemapGalGIF from "../../../public/assets/featuredArticle/sidebarArticle/basemapGal.gif";
import BMG_JPG from "../../../public/assets/featuredArticle/sidebarArticle/BMG.jpg";
import utilNetPNG from "../../../public/assets/featuredArticle/sidebarArticle/UtilNet.png";
import lyrlistPNG from "../../../public/assets/featuredArticle/sidebarArticle/lyrlist.png";
import editGIF from "../../../public/assets/featuredArticle/sidebarArticle/Edit.gif";
import themecompGIF from "../../../public/assets/featuredArticle/sidebarArticle/themecomp.gif";
import aa_measureJPG from "../../../public/assets/featuredArticle/sidebarArticle/aa_measure.jpg";

import Sanitizer from "@esri/arcgis-html-sanitizer";

@subclass("app.ui.FeaturedArticle")
export default class FeaturedArticle extends Widget {
  //--------------------------------------------------------------------------
  //
  //  Properties
  //
  //--------------------------------------------------------------------------

  @property()
  @messageBundle("dist/assets/t9n/App/App")
  appMessages: typeof AppT9N;

  @property() 
  carouselToggle: boolean = true;

  @property()
  navbarVM: NavBarViewModel;

  @property()
  _articleContainer: HTMLDivElement;

  _sanitizer = new Sanitizer();

  constructor(args){
    super(args);
  }

  postInitialize(){
    this.navbarVM.watch("_featuredArticleStateRouter", ()=>{
      if(this._articleContainer != null){
        this._articleContainer.scrollTop = 0;
      }
    })
  }

  render() {
    return (
      <div class="featured-article"
        bind={this}
        afterCreate={storeNode}
        data-node-ref="_articleContainer"
      >
        {this._renderCarouselRouter()}
      </div>
    );
  }

  private _renderCarouselRouter() {
    switch (this.navbarVM._featuredArticleStateRouter) {
      case "chartViewer":
        return this._renderChartViewerArticle();
      default:
        return this._renderSidebarArticle();
    }
  }

  private _renderChartViewerArticle(): VNode[] {
    const {
      part3,
      part4,
      part5,
      part6,
      part6_1,
      part6_2,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22,
      part23,
      part24,
      imgAlt1,
      imgAlt2,
      imgAlt3,
      imgAlt4,
      imgAlt5,
      imgAlt6,
      imgAlt7,
    } = this.appMessages.featuredArticle;

    const { 
      chartViewerArticle
    } = this.appMessages.featuredTab;
    return [
      <img
        key="header-img-chart-viewer"
        id="header-img"
        src={ChartViewerTitlePic}
        alt=""
      />,

      <div key="article-content-chart-viewer" class="article-content">
        <header id="article-header">{ chartViewerArticle }</header>

        <p>
          {part3}&nbsp;
          <a
            href="https://www.arcgis.com/home/item.html?id=be4582b38d764de0a970b986c824acde"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            { chartViewerArticle }
          </a>
          &nbsp;{part4}&nbsp;
          <a
            href="https://www.arcgis.com/apps/instant/charts/index.html?appid=5daaae106f774b95bc749dbe1b90a964"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            {part5}
          </a>
          &nbsp;{part6}
        </p>
        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/3charts.png"
            alt={imgAlt1}
            title={imgAlt1}
          />
        </div>

        <br />

        <p>{part6_1}</p>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/chartviewersidebyside.png"
            alt={`${chartViewerArticle} Instant App ${imgAlt2}`}
            title={`${chartViewerArticle} Instant App ${imgAlt2}`}
          />
        </div>

        <br />

        <p>{part6_2}</p>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/switch-layers.png"
            alt={imgAlt5}
            title={imgAlt5}
          />
        </div>

        <p>&nbsp;</p>
        <h2></h2>
        <h2>{chartViewerArticle} {part7}</h2>

        <p>
          {part8}&nbsp;
          <a 
            href="https://www.esri.com/arcgis-blog/products/arcgis-online/analytics/introducing-charts-in-map-viewer/"
            target="_blank"
          >
            {part9}
          </a>
          &nbsp;{part10}
        </p>

        <p styles={{ width: "100%" }}>{part11}</p>

        <ul styles={{ width: "100%" }}>
          <li>{part12}</li>
          <li>{part13}</li>
        </ul>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src={selectionGIF}
            alt={imgAlt4}
            title={imgAlt4}
          />
        </div>

        <ul styles={{ width: "100%" }}>
          <li>{part14}</li>
        </ul>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/chartconfig.png"
            alt={imgAlt3}
            title={imgAlt3}
          />
        </div>

        <ul styles={{ width: "100%" }}>
          <li>{part16}</li>
          <li>{part17}</li>
          <li>{part18}</li>
        </ul>
        <p>&nbsp;</p>
        <h2></h2>
        <h2>{part19}</h2>
        <p>
          {part20}&nbsp;
          <a
            href="https://www.arcgis.com/apps/instant/charts/index.html?appid=148f5599241c4795a1ef8170a4581953"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            7,000+ {part21}
          </a>
          &nbsp;{part22}
        </p>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src={museumExamplePic}
            alt={`${chartViewerArticle} ${imgAlt6}`}
            title={`${chartViewerArticle} ${imgAlt6}`}
          />
        </div>
        <p>
          <a
            href="https://www.arcgis.com/apps/instant/charts/index.html?appid=87255383148143a9b1b77c25f5cb32f0"
            target="_blank"
            rel="noopener"
            aria-describedby="new-window"
          >
            {part23}
          </a>
          &nbsp;{part24}
        </p>

        <div class="newsr-image_content">
          <img
            class="newsr-image_src"
            src="https://www.esri.com/arcgis-blog/wp-content/uploads/2021/09/generation.png"
            alt={`${chartViewerArticle} ${imgAlt7}`}
            title={`${chartViewerArticle} ${imgAlt7}`}
          />
        </div>
      </div>,
    ];
  }

  private _renderSidebarArticle(): VNode[] {
    const {
      part1,
      part2,
      part3,
      part4,
      part5,
      part6,
      part7,
      part8,
      part9,
      part10,
      part11,
      part12,
      part13,
      part14,
      part15,
      part16,
      part17,
      part18,
      part19,
      part20,
      part21,
      part22
    } = this.appMessages.featureArticle_Sidebar;
    return [
      <img
        key="header-img-sidebar"
        id="header-img"
        src={SidebarTitlePic}
        alt=""
      />,

      <div key="article-content-sidebar" class="article-content">
        <header id="article-header">{part1}</header>
        <p>{part2}</p>
        <p>
          <i innerHTML={this._sanitizer.sanitize(part3)}></i>
        </p>
        <p>&nbsp;</p>
        <h2></h2>
        <h2>{part4}</h2>
        <p>
          {part5}
        </p>
        <p>
          {part6}
        </p>
        <ul>
          <li innerHTML={this._sanitizer.sanitize(part7)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={lyrlistPNG}
                alt="Layer list example with layer picker"
                title="Layer list example with layer picker"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
          <li innerHTML={this._sanitizer.sanitize(part8)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={basemapGalGIF}
                alt="Basemap gallery configuration"
                title="Basemap gallery configuration"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>

          <li innerHTML={this._sanitizer.sanitize(part9)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={editGIF}
                alt="Editing example using the snapping feature"
                title="Editing example using the snapping feature"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
          <li innerHTML={this._sanitizer.sanitize(part10)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={utilNetPNG}
                alt="Utility network trace tool example"
                title="Utility network trace tool example"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
        </ul>

        <h2></h2>
        <h2>{part11}</h2>

        <p>
          {part12}
        </p>

        <p>
          {part13}
        </p>

        <ul>
          <li innerHTML={this._sanitizer.sanitize(part14)}></li>
          <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
            <div class="newsr-image_content">
              <img
                class="newsr-image_src"
                src={aa_measureJPG}
                alt="Measure tool example in app"
                title="Measure tool example in app"
              />
            </div>
            <figcaption class="newsr-image_caption"></figcaption>
          </figure>
          <li innerHTML={this._sanitizer.sanitize(part15)}></li>
          <li innerHTML={this._sanitizer.sanitize(part16)}></li>
          <li innerHTML={this._sanitizer.sanitize(part17)}></li>
          <li innerHTML={this._sanitizer.sanitize(part18)}></li>
        </ul>

        <h2></h2>
        <h2>{part19}</h2>

        <p>
          {part20}
        </p>

        <figure class="newsr-image newsr-image--center column-10 tablet-column-12 phone-column-6 ">
          <div class="newsr-image_content">
            <img
              class="newsr-image_src"
              src={themecompGIF}
              alt="Choosing a new theme in the theme component"
              title="Choosing a new theme in the theme component"
            />
          </div>
          <figcaption class="newsr-image_caption"></figcaption>
        </figure>

      </div>,
    ];
  }
}
